import { render, staticRenderFns } from "./CambioClave.vue?vue&type=template&id=1ef92776&scoped=true&"
import script from "./CambioClave.vue?vue&type=script&lang=js&"
export * from "./CambioClave.vue?vue&type=script&lang=js&"
import style0 from "./CambioClave.vue?vue&type=style&index=0&id=1ef92776&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef92776",
  null
  
)

export default component.exports